import { render, staticRenderFns } from "./Africa.vue?vue&type=template&id=72a30f68&"
import script from "./Africa.vue?vue&type=script&lang=js&"
export * from "./Africa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports